import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9b870dec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ConsumerDept" }
const _hoisted_2 = { class: "statitiscal" }
const _hoisted_3 = { class: "uv" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onClick"]

import { searchFormConfig } from './config/search.config'
import { contentTableConfig } from './config/content.config'
import { usePageSearch } from '@/hooks/userPageSearch'
import { toDay } from '@/utils/date-format'

import { useStore } from '@/store'
import { useRouter } from 'vue-router'
import { ref } from 'vue'
import { queryStatistical } from '@/service/main/system'


export default /*#__PURE__*/_defineComponent({
  __name: 'ConsumerDept',
  setup(__props) {

const store = useStore()

const queryParam = {
  createdTime: [toDay(), toDay()]
}
store.commit('system/changeQueyryInfo', queryParam)

const getDept = () => {
  const dept = searchFormConfig.formItems.find(
    (item) => item.field === 'deptId'
  )
  const deptData = store.state.login.depts
  dept!.options = deptData.map((item: any) => {
    return { title: item.name, value: item.id }
  })
}

getDept()

const resetCb = () => {
  return queryParam
}

const router = useRouter()

const handleDept = (item: any) => {
  router.push({
    path: '/main/consumer/consumer',
    query: {
      deptId: item.deptId,
      createdTime: store.state.system.queryInfo.createdTime
    }
  })
}
const handleChannel = (item: any) => {
  router.push({
    path: '/main/consumer/consumer',
    query: {
      channel: item.channel,
      createdTime: store.state.system.queryInfo.createdTime
    }
  })
}

const statitiscal = ref({ count: 0 })

const searchCb = async (item: any) => {
  statitiscal.value = await queryStatistical(
    '/main/consumerStatisticalDept/queryStatistical',
    item
  )
}

searchCb({ ...queryParam, pageNo: 1, pageSize: 1000 })

const [pageContentRef, handleResetClick, handleSearchClick] = usePageSearch(
  resetCb,
  searchCb
)

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_PageContent = _resolveComponent("PageContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, [
        _createTextVNode("新客户数量: "),
        _createElementVNode("em", null, _toDisplayString(statitiscal.value.count), 1)
      ])
    ]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "consumerStatisticalDept"
    }, {
      dept: _withCtx((scope) => [
        _createElementVNode("div", {
          onClick: ($event: any) => (handleDept(scope.row)),
          style: {"cursor":"pointer"}
        }, _toDisplayString(scope.row.deptName), 9, _hoisted_4)
      ]),
      channel: _withCtx((scope) => [
        _createElementVNode("div", {
          onClick: ($event: any) => (handleChannel(scope.row)),
          style: {"cursor":"pointer"}
        }, _toDisplayString(scope.row.channelName), 9, _hoisted_5)
      ]),
      _: 1
    }, 8, ["contentTableConfig"])
  ]))
}
}

})